import React from 'react';
import {fabric} from 'fabric';
class ImageList extends React.Component {
    constructor(props) {
        super(props);
      }

  
  handleImageClick=(e)=>{
    var canvas=this.props.props.designer.drawingCanvas;
    var url=""
    if(e.target.files!==undefined){
      url=URL.createObjectURL(e.target.files[0])
    }
    else{
      url = e.target.src;
    }
		/*temp code*/
		//var offset = 50;
		// var left = fabric.util.getRandomInt(0 + offset, 200 - offset);
		// var top = fabric.util.getRandomInt(0 + offset, 400 - offset);
		// var angle = fabric.util.getRandomInt(-20, 40);
		// var width = fabric.util.getRandomInt(30, 50);
		// var opacity = (function (min, max) { return Math.random() * (max - min) + min; })(0.5, 1);

		fabric.Image.fromURL(url, function (image) {
      
			image.set({
				left: 0,
				top: image.height/2,
				angle: 0,
				padding: 10,
				cornersize: 10,
				hasRotatingPoint: true,
				scaleX:Math.min((canvas.width / image.width), canvas.height / image.height) ,
				scaleY:Math.min(canvas.width / image.width, canvas.height / image.height) ,

			});
      //image.lockMovementX=true;
      //image.lockMovementY=true;
			//var ratio  = Math.min ( hRatio, vRatio );
			//image.scale(getRandomNum(0.1, 0.25)).setCoords();
      
			
			canvas.add(image);
			canvas.centerObject(image);
      if(document.getElementById('shirtSettings')){
        document.getElementById('shirtSettings').id='shirtSettingsShrink';
       }

		},{crossOrigin:'Anonymous'});
    this.props.props.increasePrice();

    }

    render() { 
        return ( 
            <div style={{height:"100%" }} >
        <div className="well" style={{margin:"10px",background:"ghostwhite"}}>       
        <label style={{fontWeight:"bold",fontSize:'18px'}}>Choose your print type</label>
        <hr className="rounded" style={{backgroundColor:"black",width:"60%",marginTop:"0px"}}/>

        <select onChange={(e)=>{this.props.props.onSelectedImageTypeChange(e.target.value)}} style={{background:"aliceblue",width:"100%",borderTop:"none",borderRight:"none",borderLeft:"none",fontSize:'22px',marginBottom:'10px'}} id="selectedType" defaultValue="half sleeves shirt" >                        
            {this.props.props.designer.printTypeImages.map((print,index)=><option key={index} value={print.type}>{print.type}</option>)}
          </select>
          <div id="uploadImageContainer">
          <span>Cant find what you are looking for ? </span>
          <label style={{cursor:"pointer"}}>
           <input onChange={(e)=>this.handleImageClick(e)}   type="file" style={{display:"none",cursor:"pointer"}}/>
              Upload your Design From Here
      </label>

        </div>
        </div>
        <div id="imageContainer">
        {
          this.props.props.designer.activeImageList.map((img,index)=>{
           return <img id="imageList" key={index} onClick={this.handleImageClick}  src={img} alt="https://i.stack.imgur.com/6M513.png"/>
           /*return <img id="imageList" onClick={this.handleImageClick}  src="https://i.pinimg.com/564x/d9/41/b5/d941b568a28a20dcf80eea68794d464a.jpg"/>*/
          })
        }
        </div>
            {/* <img id="imageList" onClick={this.handleImageClick}  src="https://i.pinimg.com/564x/d9/41/b5/d941b568a28a20dcf80eea68794d464a.jpg"/>
            <img id="imageList" onClick={this.handleImageClick}  src="https://i.pinimg.com/564x/d9/41/b5/d941b568a28a20dcf80eea68794d464a.jpg"/>
            <img id="imageList" onClick={this.handleImageClick}  src="https://i.pinimg.com/564x/d9/41/b5/d941b568a28a20dcf80eea68794d464a.jpg"/>
            <img id="imageList" onClick={this.handleImageClick}  src="https://i.pinimg.com/564x/d9/41/b5/d941b568a28a20dcf80eea68794d464a.jpg"/>
            <img id="imageList" onClick={this.handleImageClick}  src="https://i.pinimg.com/564x/d9/41/b5/d941b568a28a20dcf80eea68794d464a.jpg"/>
            <img id="imageList" onClick={this.handleImageClick}  src="https://i.pinimg.com/564x/d9/41/b5/d941b568a28a20dcf80eea68794d464a.jpg"/>
            <img id="imageList" onClick={this.handleImageClick}  src="https://i.pinimg.com/564x/d9/41/b5/d941b568a28a20dcf80eea68794d464a.jpg"/>
            <img id="imageList" onClick={this.handleImageClick}  src="https://i.pinimg.com/564x/d9/41/b5/d941b568a28a20dcf80eea68794d464a.jpg"/>
            <img id="imageList" onClick={this.handleImageClick}  src="https://i.pinimg.com/564x/d9/41/b5/d941b568a28a20dcf80eea68794d464a.jpg"/>
            <img id="imageList" onClick={this.handleImageClick}  src="https://i.pinimg.com/564x/d9/41/b5/d941b568a28a20dcf80eea68794d464a.jpg"/>
            <img id="imageList" onClick={this.handleImageClick}  src="https://i.pinimg.com/564x/d9/41/b5/d941b568a28a20dcf80eea68794d464a.jpg"/> */}




        </div>
         );    }
}
 
export default ImageList;
